// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media print {
    body::after {
        content:none!important;
        background:none!important;
    }
}

.page{
    padding-bottom:5px;
}

.page-list{
    padding-top:0px;
    padding-bottom:0px;
}

.page-list-content{
    box-shadow:rgb(84 88 91 / 25%) 0px 4px 16px, rgb(52 52 55 / 5%) 0px 8px 32px;
    overflow:hidden;
    background:#fff;
}

.page-content{
    padding:5px;
    box-shadow:rgb(84 88 91 / 25%) 0px 4px 16px, rgb(52 52 55 / 5%) 0px 8px 32px;
    overflow:hidden;
    margin-bottom:10px;
    background:#fff;
}

.body-title{
    color: darkmagenta;
}

.reset-styles * {
    all: unset;
    box-sizing: border-box;
    display: revert;
    font-family: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
    border: 0;
    text-decoration: none;
    list-style: none;
}

.countdown_blink {
    animation: blinker 1s linear infinite;
    color: red;
}
  
@keyframes blinker {
    50% {
        opacity: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/core/App.css"],"names":[],"mappings":";AACA;IACI;QACI,sBAAsB;QACtB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,4EAA4E;IAC5E,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,4EAA4E;IAC5E,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":["\n@media print {\n    body::after {\n        content:none!important;\n        background:none!important;\n    }\n}\n\n.page{\n    padding-bottom:5px;\n}\n\n.page-list{\n    padding-top:0px;\n    padding-bottom:0px;\n}\n\n.page-list-content{\n    box-shadow:rgb(84 88 91 / 25%) 0px 4px 16px, rgb(52 52 55 / 5%) 0px 8px 32px;\n    overflow:hidden;\n    background:#fff;\n}\n\n.page-content{\n    padding:5px;\n    box-shadow:rgb(84 88 91 / 25%) 0px 4px 16px, rgb(52 52 55 / 5%) 0px 8px 32px;\n    overflow:hidden;\n    margin-bottom:10px;\n    background:#fff;\n}\n\n.body-title{\n    color: darkmagenta;\n}\n\n.reset-styles * {\n    all: unset;\n    box-sizing: border-box;\n    display: revert;\n    font-family: inherit;\n    color: inherit;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    text-decoration: none;\n    list-style: none;\n}\n\n.countdown_blink {\n    animation: blinker 1s linear infinite;\n    color: red;\n}\n  \n@keyframes blinker {\n    50% {\n        opacity: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
